import { Component, GondelBaseComponent, EventListener } from '@gondel/core';

/**
 * news-story-subscription module implementation.
 * @author Nikola Antic <nikola.antic@emea.merkleinc.com>
 */

enum Selectors {
	wrap = '.js-m-news-story-subscription__wrap',
	form = '.js-m-news-story-subscription__wrap form',
	input = '.js-m-news-story-subscription__wrap form input',
	title = '.js-m-news-story-subscription__title',
}

/**
 * All custom attributes inside the current _ctx object
 */
enum CustomAttributes {
	formId = 'data-form-id',
	titleSuccess = 'data-title-success',
}

@Component('NewsStorySubscription')
export class NewsStorySubscription extends GondelBaseComponent {
	private _form: HTMLFormElement = {} as HTMLFormElement;
	private _input: HTMLInputElement = {} as HTMLInputElement;
	private _title: HTMLParagraphElement = {} as HTMLParagraphElement;

	public start() {
		this._form = this._ctx.querySelector(Selectors.form) as HTMLFormElement;
		this._input = this._ctx.querySelector(Selectors.input) as HTMLInputElement;
		this._title = this._ctx.querySelector(Selectors.title) as HTMLParagraphElement;
	}

	@EventListener('submit', Selectors.form)
	private _onSubmitForm(event: Event): void {
		event.preventDefault();

		const formId = this._ctx.getAttribute(CustomAttributes.formId) as string;
		const titleSuccessText = this._ctx.getAttribute(CustomAttributes.titleSuccess) as string;
		const formEndpoint = this._form.action;
		const data = {
			email: this._input.value,
			webform_id: '',
		};

		if (formId) {
			data.webform_id = formId;
		}

		fetch(formEndpoint, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(data),
		}).then((response) => {
			if (response.ok && this._title && titleSuccessText) {
				this._title.innerText = titleSuccessText;
			}
		});
	}
}
